
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/account/order-history",
      function () {
        return require("private-next-pages/[region]/[lang]/account/order-history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/account/order-history"])
      });
    }
  